<div>
  <mat-sidenav-container [hasBackdrop]="false" autosize style="height: calc(100vh - 50px); width:100%">
    <mat-sidenav #sidenav mode="side" opened style="display: block;">
      <mat-nav-list>
        <a *ngIf="aclGroup.policy" mat-list-item style="height: 30px;" (click)="policy()"><button mat-button
            style="height: 30px; font-size: 11pt;" class="navbar-items"> Policy</button></a>
        <a *ngIf="aclGroup.retention" mat-list-item style="height: 30px;" (click)="retentionGroup()"><button style="height: 30px; font-size: 11pt;"
            mat-button class="navbar-items"> Retention</button></a>
        <a *ngIf="aclGroup.hold" mat-list-item style="height: 30px;" (click)="holdGroup()"><button mat-button
            style="height: 30px; font-size: 11pt;" class="navbar-items">Hold</button></a>
        <a *ngIf="aclGroup.purgeList" mat-list-item style="height: 30px;" (click)="disposition()"><button mat-button
            style="height: 30px; font-size: 11pt;" class="navbar-items">Purge List</button></a>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content style="margin-right: 0; padding:0">
      <div>
        <div class="card p-2 m-2" *ngIf="!isPolicy && !isRetentionGroup && !isHoldGroup && !isDisposition">
          <div class="card-body p-2">
            Please select
          </div>
        </div>
        <div class="p-2 m-1" *ngIf="isPolicy">
          <app-policy></app-policy>
        </div>
        <div class="p-2 m-1" *ngIf="isRetentionGroup">
          <app-retention></app-retention>
        </div>
        <div class="p-2 m-1" *ngIf="isHoldGroup">
          <app-holds></app-holds>
        </div>
        <div class="p-2 m-1" *ngIf="isDisposition">
          <app-purge-list></app-purge-list>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>